import { style } from "@vanilla-extract/css";

import { theme } from "../../../theme/css/theme.css";

export const setStyle = style({
  gap: theme.spacings.m,
  padding: `${theme.spacings.s} 0 0`,
  width: "100%",
  flexShrink: 0,
  flexGrow: 0,
});

export const chatListStyle = style({
  gap: theme.spacings.xs,
  width: "100%",
});
